import { ConsultationDataDto } from '~containers/app/ask-a-vet/types'
import Consultation from '~models/consultation'
import api from '~utils/http'
import Sentry from '~utils/sentry'

class ConsultationRepositoryImpl {
  async getConsultationDetail(consultationId: number | string) {
    return new Consultation.Level2(
      (
        await api.get<Consultation.ILevel2>(`/app/consultations/${consultationId}/`, {
          withCredentials: true,
        })
      ).data
    )
  }

  async getRelatedConsultations(consultationId: number | string) {
    /**
     * @TODO: MODEL_QUERY_KEYS.consultation.level1 에 데이터를 저장
     */

    return (
      await api.get<Consultation.ILevel1[]>(`/app/consultations/${consultationId}/related/`, {
        withCredentials: true,
      })
    ).data.map(consultation => new Consultation.Level1(consultation))
  }

  async createConsultation(draft: ConsultationDataDto) {
    const res = new Consultation.Level2(
      (
        await api.post<Consultation.ILevel2>(`/app/consultations/`, draft, {
          withCredentials: true,
        })
      ).data
    )

    try {
      const concernLevelData = await ConsultationRepositoryImpl.requestConsultationConcernLevel(
        res.id
      )
      res.concern_lv = concernLevelData.concern_lv
      res.concern_lv_expression = concernLevelData.concern_lv_expression
      res.concern_lv_description = concernLevelData.concern_lv_description
      res.issue_review = concernLevelData.issue_review
    } catch (error) {
      console.error(error)
      Sentry.captureException(error)
    }

    return res
  }

  // @TODO: 임시 이 절차가 합쳐지면 삭제
  static async requestConsultationConcernLevel(consultationId: number | string) {
    return (
      await api.post<Consultation.ConcernLevel>(
        `/app/consultations/${consultationId}/concern_lv/`,
        null,
        {
          withCredentials: true,
        }
      )
    ).data
  }
}

const ConsultationRepository = new ConsultationRepositoryImpl()
export default ConsultationRepository
